var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZipThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.47008 0C5.11154 0 4 1.125 4 2.5V37.5C4 38.875 5.11154 40 6.47008 40H31.1709C32.5294 40 33.6409 38.875 33.6409 37.5V10L23.7606 0H6.47008Z",
    fill: "#FFE190"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4502 10H33.6425L24.0527 0V7.5C24.0527 8.875 25.1316 10 26.4502 10Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.642 17.2727L25.7959 10H33.642V17.2727Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8081 10H34.0004L24.4106 0V7.5C24.4106 8.875 25.4895 10 26.8081 10Z",
    fill: "#B0B7BD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6409 31.3333C29.6409 32 29.0852 32.5455 28.4059 32.5455H1.23504C0.555768 32.5455 0 32 0 31.3333V19.2121C0 18.5455 0.555768 18 1.23504 18H28.4059C29.0852 18 29.6409 18.5455 29.6409 19.2121V31.3333Z",
    fill: "#46474A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5213 27.77V27.79H13.0713C13.1813 27.79 13.2613 27.88 13.2613 27.98V28.81C13.2613 28.91 13.1813 29 13.0713 29H8.80133C8.70133 29 8.61133 28.91 8.61133 28.81C8.61133 28.7 8.61133 28.63 8.68133 28.5L11.5913 23.25V23.21H9.09133C8.99133 23.21 8.90133 23.12 8.90133 23.02V22.19C8.90133 22.09 8.99133 22 9.09133 22H13.2713C13.3713 22 13.4613 22.09 13.4613 22.19C13.4613 22.25 13.4613 22.32 13.3713 22.48L10.5213 27.77ZM14.5922 28.81V22.19C14.5922 22.09 14.6822 22 14.7822 22H15.7122C15.8122 22 15.9022 22.09 15.9022 22.19V28.81C15.9022 28.91 15.8122 29 15.7122 29H14.7822C14.6822 29 14.5922 28.91 14.5922 28.81ZM17.6 28.81V22.19C17.6 22.09 17.68 22 17.79 22H20.14C21.37 22 22.38 23 22.38 24.21C22.38 25.45 21.37 26.46 20.15 26.46H18.9V28.81C18.9 28.91 18.81 29 18.71 29H17.79C17.68 29 17.6 28.91 17.6 28.81ZM18.9 25.24H20.1C20.66 25.24 21.09 24.79 21.09 24.2C21.09 23.65 20.66 23.23 20.1 23.23H18.9V25.24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipThumb);
export default __webpack_public_path__ + "static/media/zip-thumb.5b5db31ad4222231bb69942a457372d7.svg";
export { ForwardRef as ReactComponent };